import { render, staticRenderFns } from "./ProgramIndex.vue?vue&type=template&id=d99221c0&scoped=true&"
import script from "./ProgramIndex.vue?vue&type=script&lang=js&"
export * from "./ProgramIndex.vue?vue&type=script&lang=js&"
import style0 from "./ProgramIndex.vue?vue&type=style&index=0&id=d99221c0&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d99221c0",
  null
  
)

export default component.exports